import React from "react";
import PropTypes from 'prop-types';

import Base from "../Base";
import withInput from "../../../hoc/withInput";

class TextareaInput extends Base {
	input() {
		const { id, inputValue } = this.props;
		
		return(
			<textarea id={ id } name={ id } value={ inputValue } onChange={ ( e ) => {
				this.onChange( e.target.value );
			} } />
		);
	}
}


TextareaInput.propTypes = {
	id: PropTypes.string,
	inputValue: PropTypes.string,
};

export default withInput( TextareaInput );
